function initMediaDots() {
  document.querySelectorAll('[data-media-dots]').forEach((dots) => {
    if (dots.dataset.dotsInitialized) return;

    const sliderComponent = dots.closest('slider-component');
    const list = sliderComponent && sliderComponent.querySelector('.product__media-list--dots');
    const dotButtons = Array.from(dots.querySelectorAll('.product__media-dots__dot'));
    if (!list || !dotButtons.length) return;

    dots.dataset.dotsInitialized = 'true';

    // Re-read list.children on every call instead of caching it once: product-info.js
    // reorders these <li> elements on every variant change (it prepends the new variant's
    // featured slide to the front), so a cached array goes stale and maps dot index -> wrong
    // element, lighting up the wrong dot as you scroll.
    const getItems = () => Array.from(list.children);

    const setActive = (index) => {
      dotButtons.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    const update = () => {
      const scrollLeft = list.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Infinity;

      getItems().forEach((item, i) => {
        const distance = Math.abs(item.offsetLeft - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });

      setActive(closestIndex);
    };

    dotButtons.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        const item = getItems()[i];
        if (item) list.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      });
    });

    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMediaDots);
} else {
  initMediaDots();
}

document.addEventListener('shopify:section:load', initMediaDots);
